export const fromIsoDateToLocaleDate = (date, locale = "fr") => {
  const d = new Date(date);
  return d
    ? `${d.toLocaleDateString(locale)} ${d.toLocaleTimeString(locale)}`
    : "";
};

export const fromIsoDateToLocaleOnlyDate = (date, locale = "fr") => {
  const d = new Date(date);
  return d ? `${d.toLocaleDateString(locale)}` : "";
};
